import * as _ from 'lodash'
import { Variable, VBoolean } from 'alkali'
import { Annotation, ASSIGNABLE } from './model/Annotations'
import { userSelectable } from './model/Annotators'
import { AnnotationModel, TextSpan } from './AnnotatableText'
import AnnotationMark from './AnnotationMark'
import { ExtractField } from 'components/extract/Inputs'
import Abstract from './model/Abstract'
import AnnotatedAbstract from './model/AnnotatedAbstract'

export interface FocusedState {
	focused?: string
	focusedField?: ExtractField
}

export default class ExtractAnnotationModel implements AnnotationModel {
	readonly focusedState: Variable<FocusedState> = new Variable({})
	constructor(readonly abstract: Variable<Abstract>,
	            readonly annotatedAbstract: Variable<AnnotatedAbstract>,
	            readonly hideRemoteAnnotations: VBoolean = new VBoolean(false)) {}

	createTextSpan(text: string, textOffset: number, annotEls: Map<Annotation, Element>) {
		return new TextSpan({ textOffset }, text)
	}

	createAnnotationSpan(annotation: Annotation, annotEls: Map<Annotation, Element>) {
		if (annotation.interactive != false) {
			if (!this.hideRemoteAnnotations.valueOf() || annotation.source == 'user') {
				return new AnnotationMark({
					textOffset: annotation.start,
					annot: annotation,
					annotEls,
					onAssignAnnotation: a => this.onAssignAnnotation(a),
					onDeleteAnnotation: a => this.onDeleteAnnotation(a)
				})
			} else {
				return this.createTextSpan(annotation.text, annotation.start, annotEls)
			}
		} else {
			// for now don't allow interaction with "labels"
			return new TextSpan(`.dre-ds-ann.${annotation.type}`, { textOffset: annotation.start }, annotation.text)
		}
	}

	canSelect(): boolean {
		const focused = this.focusedState.valueOf().focused
		return focused && userSelectable(focused)
	}

	selecting(): VBoolean {
		return this.focusedState.property('focused').to(f => f && userSelectable(f))
	}

	handleSelection(selected: string, offset: number, end: number, overlapped: Annotation[]) {
		const newAnnots = this.annotationsFromSelection(offset, end)
		this.onCreateAnnotations(newAnnots)
		//let firstUnknown = newAnnots.find(a => a.type == 'unknown')
		// if (firstUnknown) {
		//   _.defer(() => {
		//     const e = this.annotEls.get(firstUnknown)
		//     if (e) {
		//       // toggle popover for new annotation if type was unknown
		//       e.pop()
		//     }
		//   })
		// }
	}

	private annotationsFromSelection(start, end): Annotation[] {
		const abs = this.annotatedAbstract.valueOf()
		const text = abs.abstract.text
		const selected = text.slice(start, end)
		const section = abs.abstract.findSection(start, end)
		const sentence = abs.abstract.findSentence(start, end)
		const focusedType = this.focusedState.valueOf().focused
		return abs.annotateLocal({ text: selected, start, end: end - 1, section, sentence }, [focusedType])
	}

	private onCreateAnnotations(annotations: Annotation[]) {
		annotations.some(a => this.onAssignAnnotation(a))
	}

	private onDeleteAnnotation(annotation) {
		this.annotatedAbstract.valueOf().deleteAnnotations([annotation])
	}

	private onAssignAnnotation(annotation) {
		const { focused, focusedField } = this.focusedState.valueOf()
		if (focused) {
			if (_.intersection(ASSIGNABLE[focused] || [focused], annotation.types).length) {
				//this.focusedState.focusedField.value.put(annotation.captured || annotation.text)
				focusedField.setAnnotation(annotation)
				return true
			}
		}
	}
}